import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CarViewModel, IFilterItemViewModel } from '@ncg/data';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ncg-product-item-tags',
    template: `
        <div
            [ngClass]="'product-item__tags--' + variant + ' is-flex-direction-' + direction"
            class="product-item__tags"
            *ngIf="item.premium || item.isFeatured || item.isDemo"
        >
            <div class="product-item__tag product-item__tag--primary product-item__tag--premium" *ngIf="item.premium">
                {{ item.premium }}
            </div>
            <div class="product-item__tag product-item__tag--primary" *ngIf="item.isDemo && !item.premium">
                {{ 'facet_types.isdemo' | translate }}
            </div>
            <div class="product-item__tag product-item__tag--secondary" *ngIf="item.isFeatured">
                {{ 'product_item.featured' | translate }}
            </div>
        </div>
    `,
    standalone: true,
    imports: [CommonModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductItemTagsComponent {
    @Input() item: IFilterItemViewModel | CarViewModel;
    @Input() variant: 'default' | 'large' = 'default';
    @Input() direction: 'row' | 'column' = 'row';
}
